/**
 * Product description: na 3 regels afknippen met gelokaliseerde show more/show less knop.
 */
(function () {
  const LINES = 3;
  const LABEL_READ_MORE = Theme?.translations?.show_more || 'Show more';
  const LABEL_READ_LESS = Theme?.translations?.show_less || 'Show less';

  function findDescriptionBlock() {
    const productInfo = document.querySelector('.product-information');
    if (!productInfo) return null;
    const productDetails = productInfo.querySelector('.product-details');
    if (!productDetails) return null;
    // Alleen tekstblokken binnen product-details; kies het langste (meestal de beschrijving)
    const candidates = productDetails.querySelectorAll('.text-block, rte-formatter');
    let best = null;
    let bestLength = 0;
    for (const el of candidates) {
      if (el.closest('.product-description-readmore')) continue;
      const text = (el.textContent || '').trim();
      if (text.length < 80) continue;
      if (text.length > bestLength) {
        bestLength = text.length;
        best = el;
      }
    }
    return best;
  }

  function needsReadMore(el) {
    const style = getComputedStyle(el);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
    const maxHeight = lineHeight * LINES;
    return el.scrollHeight > maxHeight + 2;
  }

  function init() {
    const el = findDescriptionBlock();
    if (!el) return;
    if (!needsReadMore(el)) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'product-description-readmore';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'product-description-readmore__toggle';
    toggle.textContent = LABEL_READ_MORE;
    toggle.setAttribute('aria-expanded', 'false');

    el.classList.add('product-description-readmore__content');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    wrapper.appendChild(toggle);

    toggle.addEventListener('click', function () {
      const expanded = wrapper.classList.toggle('product-description-readmore--expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? LABEL_READ_LESS : LABEL_READ_MORE;
    });
  }

  function run() {
    init();
    // Opnieuw proberen na korte vertraging (voor dynamisch geladen content of theme editor)
    setTimeout(init, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
